<div class="flex flex-col gap-5 justify-center items-center">
  <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-x-6 gap-y-2 w-full!">
    <div
      class="grid gap-5"
      [ngClass]="{
        'grid-cols-1': clientSectionColumm === 1,
        'grid-cols-1 lg:grid-cols-2 ': clientSectionColumm === 2,
      }"
    >
      <app-client-section
        [quotationId]="quotationId"
        [ticketId]="ticketId"
        (clientReturn)="updateCustomer($event)"
      ></app-client-section>

      <app-asset-section
        [quotationId]="quotationId"
        [ticketId]="ticketId"
        (assetReturn)="updateAsset($event)"
      ></app-asset-section>
    </div>

    <app-financing-section
      [financingSectionColumm]="clientSectionColumm"
      class="w-full"
      [quotationId]="quotationId"
      [ticketId]="ticketId"
      [selectedBrand]="selectedBrand"
      [modelSelected]="modelSelected"
      [planTypes]="planTypes"
      (financingReturn)="updatefinancing($event)"
      (comparativeComponentReturn)="updateComparative($event)"
    ></app-financing-section>

    <div class="px-4! py-1.5! flex flex-row-reverse border-primary border-b">
      <div class="flex">
        <button mat-icon-button [matTooltip]="'2 columnas'" (click)="clientSectionColumm = 2">
          <mat-icon class="mb-1.25">view_cozy</mat-icon>
        </button>
        <button mat-icon-button [matTooltip]="'1 columna'" (click)="clientSectionColumm = 1">
          <mat-icon class="mb-1.25">splitscreen_portrait</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <app-premises-section
    class="w-full"
    (comparativeComponentReturn)="restartComparative()"
    [selectedProgram]="selectedProgram"
    [selectedBrand]="selectedBrand"
    [selectedCoverages]="selectedCoverages"
    [selectedDeadLines]="selectedDeadLines"
    [quotationId]="quotationId"
    [ticketId]="ticketId"
  ></app-premises-section>

  <div class="general-simple-box p-3 xl:p-6 flex flex-col gap-x-6 gap-y-2 w-full!">
    <app-sticky-toolbar
      class="w-full"
      [quotationId]="quotationId"
      [comparativeData]="comparativeData"
      [activeQuotationPDFInput]="activeQuotationPDF"
      [selectedDeadLineInput]="selectedDeadline"
      [selectedPersonType]="selectedPersonType"
      (updateComparative)="refreshComparative()"
    ></app-sticky-toolbar>

    @if (activateComparative) {
      <app-comparative
        [comparativeData]="comparativeData"
        [Page]="Page"
        [updateEnabled]="!activeFinancing"
        class="w-full"
        [quotationId]="quotationId"
        (selectQuotationOutDataOut)="GetQuotationPDF($event)"
        (resetQuotationEvent)="finishQuotation($event)"
      ></app-comparative>
    }
  </div>
</div>
